import ChecklistCollection from '@repo/datalayer/store/models/ChecklistCollection'
import TemplateCollection from '@repo/datalayer/store/models/TemplateCollection'
import { observer } from 'mobx-react-lite'
import { useRouter } from '../../hooks/router'
import { useStore } from '../../hooks/store'
import { AddChecklistDialogButton } from './AddChecklistDialogButton'
import { AddTemplateDialogButton } from './AddTemplateDialogButton'
import { CurrentChecklists } from './CurrentChecklists'
import { Greeting } from './Greeting'
import { RecentChecklists } from './RecentChecklists'
import { RecentTemplates } from './RecentTemplates'
import { Onboarding } from './Onboarding'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Subscription } from './Subscribe'

export const HomePageView = observer(function HomePage({
  templates,
  currentChecklists,
  recentChecklists,
  showOnboarding,
}: {
  currentChecklists: ChecklistCollection
  recentChecklists: ChecklistCollection
  templates: TemplateCollection
  showOnboarding: boolean
}) {
  const store = useStore()
  const router = useRouter()
  const { t } = useTranslation()

  return (
    <main className="max-w-[900px] mx-auto w-full">
      <div className="px-4 py-6">
        {showOnboarding && <Onboarding />}
        <Subscription />
        <div className="mb-8">
          <Greeting />

          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-muted-foreground">
              {currentChecklists.isReady
                ? currentChecklists.items.length > 0
                  ? `You have ${currentChecklists.items.length} active ${
                      currentChecklists.items.length === 1
                        ? 'checklist'
                        : 'checklists'
                    }`
                  : 'No active checklists right now'
                : ' '}
            </p>

            <div className="flex flex-wrap gap-2">
              <AddChecklistDialogButton
                onSave={async (name) => {
                  const newChecklist = await store.createChecklist(name)
                  toast.success(t('checklists.created'))

                  router.navigateToChecklist(newChecklist.id)
                }}
              />
              <AddTemplateDialogButton
                onSave={async (name) => {
                  const newTemplate = await store.createTemplate(name)
                  toast.success(t('templates.created'))

                  router.navigateToTemplate(newTemplate.id)
                }}
              />
            </div>
          </div>
        </div>

        <CurrentChecklists
          checklists={currentChecklists}
          onDelete={async (id) => {
            await store.deleteChecklist(id)
            toast.success(t('checklists.deleted'))
            currentChecklists.fetch()
          }}
        />
        <RecentTemplates
          templates={templates}
          onStart={async (id) => {
            store.startChecklist(id).then((checklist) => {
              toast.success(t('checklists.started'))
              router.navigateToChecklist(checklist.id)
            })
          }}
        />
        <RecentChecklists checklists={recentChecklists} />
      </div>
    </main>
  )
})
